import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { completeTour } from 'api/actions/userMetadata/userMetadataActions'
import { CompleteTourPayload } from 'api/actions/userMetadata/userMetadataActions.types'
import { Mutations } from 'api/mutations.enum'

export const useCompleteTour = () => {
    const mutation = useMutation<void, AxiosError, CompleteTourPayload>({
        mutationKey: [Mutations.completeTour],
        mutationFn: completeTour,
    })

    return mutation
}
